import React, { useEffect, useState } from "react";
import { BellIcon } from "@heroicons/react/24/outline";
import { motion, AnimatePresence } from "framer-motion";
import { getAllSessionNotifications, readNotification } from "../utils/api";
import { useUserContext } from "../utils/hooks/UserContext";
import { Link } from "react-router-dom";

// 🔔 Mock Notifications
const mockNotifications = [
  { id: 1, title: "New comment on your post", read: false },
  { id: 2, title: "Friend request from Alice", read: false },
  { id: 3, title: "Update available", read: false },
];

const dropdownVariants = {
  hidden: { opacity: 0, scale: 0.95, y: -10 },
  visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.2 } },
  exit: { opacity: 0, scale: 0.95, y: -10, transition: { duration: 0.15 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: -20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.08 },
  }),
};

const NotificationDropdown = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadNotification] = useState(0);

  const { user } = useUserContext();
  console.log("userssss", user);
  // const unreadCount = notifications.filter((n) => !n.read).length;

  const handleToggle = () => {
    setShowDropdown((prev) => !prev);
  };

  // const markAsRead = (id) => {
  //   setNotifications((prev) =>
  //     prev.map((notif) => (notif.id === id ? { ...notif, read: true } : notif))
  //   );
  // };

  const markAllAsRead = async () => {
    // setNotifications((prev) => prev.map((notif) => ({ ...notif, read: true })));
    try {
      const response = await readNotification();
      fetchNotifications();
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };
  const { fetchNotifications, notification, unreadNotification } = useUserContext();

  useEffect(() => {
    console.log("notiiiii")
    fetchNotifications();
  }, []);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onClick={handleToggle}
        className="relative p-2 rounded-full text-slate-600 border-2 border-[#0f5c5b] bg-slate-50 focus:outline-none hover:shadow-md transition"
      >
        <span className="absolute -inset-1.5" />
        <BellIcon aria-hidden="true" className="size-6" />

        <span className="absolute top-0 right-0 block w-4 h-4 text-xs leading-4 text-center text-white bg-red-500 rounded-full shadow-md">
          {unreadNotification || 0}
        </span>
      </button>

      <AnimatePresence>
        {showDropdown && (
          <motion.div
            variants={dropdownVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="absolute right-0 h-[23rem] overflow-y-auto z-10 p-4 mt-3 bg-white border border-gray-200 shadow-xl w-96 rounded-xl"
          >
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-base font-semibold text-slate-700">
                Notifications
              </h4>
              <img
                onClick={() => setShowDropdown(false)}
                className="absolute top-1 right-1 w-[1.3rem] "
                src="https://img.icons8.com/flat-round/50/cancel--v3.png"
                alt=""
              />
              {unreadNotification > 0 && (
                <button
                  onClick={markAllAsRead}
                  className="text-sm text-blue-600 hover:underline"
                >
                  Mark all as read
                </button>
              )}
            </div>

            {notification.length === 0 ? (
              <motion.div
                variants={itemVariants}
                initial="hidden"
                animate="visible"
              >
                <img
                  src="https://cdni.iconscout.com/illustration/premium/thumb/no-notifications-illustration-download-in-svg-png-gif-file-formats--notification-empty-state-mail-states-pack-science-technology-illustrations-7882956.png"
                  className="mx-auto"
                  alt=""
                />
              </motion.div>
            ) : (
              notification.map((notif, index) => (
                <motion.div
                  key={notif.id}
                  variants={itemVariants}
                  initial="hidden"
                  animate="visible"
                  custom={index}
                  className={`p-3 rounded-lg mb-2 border transition ${
                    notif.notification_read
                      ? "bg-gray-50 text-gray-500"
                      : "bg-teal-50 text-slate-800"
                  }`}
                >
                  <h5 className="text-sm font-bold">{notif.title}</h5>
                  <div
                    className="text-sm font-medium"
                    dangerouslySetInnerHTML={{ __html: notif.body }}
                  ></div>


                  {notif?.url && notif?.url !== 'undefined' && notif?.url.trim() !== '' && (
                    <Link
                      // onClick={() => markAsRead(notif.id)}
                      to={notif.url}
                      className="mt-1 text-xs text-teal-600 hover:underline"
                    >
                      View Details
                    </Link>
                  )}
                </motion.div>
              ))
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NotificationDropdown;
